import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigured = Boolean(url && anonKey);

if (!supabaseConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY - submissions will fail until these are exported and `yarn start` is restarted."
  );
}

// Use safe placeholders when env is missing so createClient doesn't throw on
// module load (a throw here would blank-screen the whole app).
export const supabase = createClient(
  url || "https://placeholder.supabase.co",
  anonKey || "placeholder-anon-key"
);
